/**
 * Identificador para conocer desde donde esta haciendo el proceso
 */
export enum Procedencia  {
    GESTION_BOLETOS = 'gestionboleto',
    MI_CUENTA = 'micuenta',
}